import { useMemo } from "react";
import { encode } from "uqr";

/** Renders a QR code as React SVG elements (no HTML injection). */
export function QrCode({
  value,
  size = 184,
  label,
}: {
  value: string;
  size?: number;
  label: string;
}) {
  const path = useMemo(() => {
    const { data } = encode(value, { ecc: "M", border: 2 });
    let d = "";
    data.forEach((row, y) => {
      row.forEach((on, x) => {
        if (on) d += `M${x} ${y}h1v1h-1z`;
      });
    });
    return { d, modules: data.length };
  }, [value]);

  return (
    <svg
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`0 0 ${path.modules} ${path.modules}`}
      shapeRendering="crispEdges"
      className="rounded-xl bg-white p-1"
    >
      <rect width={path.modules} height={path.modules} fill="#ffffff" />
      <path d={path.d} fill="#0f1d3a" />
    </svg>
  );
}
